import { useCurrentOrg } from 'store/organizations/selectors';

export const useOragnization = () => {
  const currentOrg = useCurrentOrg();


  return {
    currentOrg,
  };
};
